import { DieTypes } from "@/constants";
import type { DieType, Manifest, ManifestNode } from "@/types";

export const getScales = (manifests: Record<string, Manifest>) =>
  Object.entries(manifests).reduce(
    (acc, [setId, manifest]) => {
      Object.entries(manifest || {})
        .filter(([k]) => Boolean(DieTypes[k as unknown as DieType]))
        .forEach(([key, v]) => {
          const value = v as ManifestNode;
          if (!value.scale) return;
          if (!acc[setId]) {
            acc[setId] = {};
          }

          acc[setId][key] = value.scale;
        });

      return acc;
    },
    {} as Record<string, Record<string, ManifestNode["scale"]>>,
  );
